<template>
  <div class="bg-brand-black min-h-screen flex lg:bg-white">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto w-full max-w-screen-sm lg:w-96 shadow-lg lg:shadow-none px-16 py-12 rounded-lg lg:p-0 bg-white">
        <h2 class="text-center text-2xl tracking-tight leading-9 font-extrabold text-gray-900">
          Logging you out...
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  /* dispatching LOGOUT action in router.ts */
};
</script>
